module.exports = __webpack_public_path__ + "img/4.b26dace0.png";